import { put, takeEvery } from 'redux-saga/effects';
import RoboticMowerSocketReasonConstants from '~/constants/robotic-mower-socket-reason-constants';
import * as roboticMowerCommandActions from '~/ducks/robotic-mower-command/actions';
import * as roboticMowerCommandErrorsActions from '~/ducks/robotic-mower-command-errors/reducer';
import * as roboticMowerLoadingStateActions from '~/ducks/robotic-mower-loading-states/reducer';
import RoboticMowerCommand from '~/ducks/robotic-mower-command/robotic-mower-command';
import RoboticMowerSetting from '~/ducks/robotic-mower-command/robotic-mower-setting';

export function* socketReceiveMower({
  payload: { reason, roboticMower },
}: ReturnType<typeof roboticMowerCommandActions.socketReceiveRoboticMower>) {
  const assetId = roboticMower.id;
  const missionId = roboticMower.missionId;

  const loadingStateMessage = {
    missionId,
    assetId,
    loadingState: false,
  };

  // Remove loading states
  switch (reason) {
    case RoboticMowerSocketReasonConstants.START_COMMAND_FAIL:
    case RoboticMowerSocketReasonConstants.START_COMMAND_SUCCESS:
      yield put(roboticMowerLoadingStateActions.setIsStarting(loadingStateMessage));
      break;

    case RoboticMowerSocketReasonConstants.PARK_COMMAND_FAIL:
    case RoboticMowerSocketReasonConstants.PARK_COMMAND_SUCCESS:
      yield put(roboticMowerLoadingStateActions.setIsParking(loadingStateMessage));
      break;

    case RoboticMowerSocketReasonConstants.UPDATE_MISSION_COMMAND_SUCCESS:
    case RoboticMowerSocketReasonConstants.UPDATE_MISSION_COMMAND_FAIL:
      yield put(roboticMowerLoadingStateActions.setIsSettingMissionStatus(loadingStateMessage));
      yield put(roboticMowerLoadingStateActions.setIsSettingPattern(loadingStateMessage));
      break;
  }

  // Add error commands
  switch (reason) {
    case RoboticMowerSocketReasonConstants.START_COMMAND_FAIL:
      yield put(
        roboticMowerCommandErrorsActions.addErrorCommand({
          missionId,
          assetId,
          commandName: RoboticMowerCommand.START,
        })
      );
      break;

    case RoboticMowerSocketReasonConstants.PARK_COMMAND_FAIL:
      yield put(
        roboticMowerCommandErrorsActions.addErrorCommand({
          missionId,
          assetId,
          commandName: RoboticMowerCommand.PARK,
        })
      );
      break;

    case RoboticMowerSocketReasonConstants.SET_CUTTING_HEIGHT_COMMAND_FAIL:
      yield put(
        roboticMowerCommandErrorsActions.addErrorCommand({
          missionId,
          assetId,
          commandName: RoboticMowerSetting.CUTTING_HEIGHT,
        })
      );
      break;

    case RoboticMowerSocketReasonConstants.SET_SCHEDULE_COMMAND_FAIL:
      yield put(
        roboticMowerCommandErrorsActions.addErrorCommand({
          missionId,
          assetId,
          commandName: RoboticMowerSetting.SCHEDULE,
        })
      );
      break;

    case RoboticMowerSocketReasonConstants.UPDATE_MISSION_COMMAND_FAIL:
      yield put(
        roboticMowerCommandErrorsActions.addErrorCommand({
          missionId,
          assetId,
          commandName: RoboticMowerSetting.PATTERN,
        })
      );
      break;

    default:
      break;
  }
}

export function* socketReceiveMowerSaga() {
  yield takeEvery(roboticMowerCommandActions.socketReceiveRoboticMower.type, socketReceiveMower);
}

export default [socketReceiveMowerSaga];
